<template>
  <div :style="{ padding: title ? '10px' : '' }" :class="Background">
    <div class="flex-row start middle" style="padding: 10px" v-if="title || titles">
      <div style="color: #000; font-weight: 700; font-size: 18px">
        {{ title || titles }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    options: Array,
    title: String,
    icon: String,
    config: Object,
  },
  computed: {
    titles() {
      if (this.options && this.options.length) {
        return this.options[0].Position;
      }
    },
    Background() {
      if (this.config) {
        let background = this.config.Columns.find((col) => {
          return !!col.Background;
        });
        if (background) return background;
        return "panel2";
      }
      return 'panel1'
    },
  },
};
</script>
<style scoped>
.title-label {
  width: 5px;
  height: 19px;
  background: #ab0b22;
  display: inline-block;
  margin-top: 0px;
  vertical-align: bottom;
  margin-right: 5px;
}

.border-bottom {
  position: relative;
}

.border-bottom::after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 5px;
  right: 0;
  border-bottom: 0.05rem solid #eee;
  color: #eee;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
}
</style>
